// extracted by mini-css-extract-plugin
export var scrollArea = "_os-0";